import React, {CSSProperties, useEffect, useState} from 'react';
import {Button, ConfigProvider, DatePicker, Input, Select, Table, theme, TimePicker, Tooltip} from "antd";
import {ColumnsType} from "antd/es/table";
import 'dayjs/locale/ko'; // 또는 사용하고자 하는 로케일에 맞게 변경
import locale from 'antd/locale/ko_KR';
import dayjs from "dayjs";
import {TB_MONITORING_RFC, TB_MONITORING_RFC_RETURN} from "./data/MonitorMgrData";
import {formatDate, getCurrentDateTime} from "../../../../../Common/util/DateUtil";
import {procAdminService} from "../../../../../Common/util/ProcService";
import EllipsisDiv from "../../common/component/EllipsisDiv";
import WizTooltip from "../../../../../Common/component/WizTooltip/WizTooltip";
import {handleCopyClick} from "../../../../../Common/util/ClipboardUtil";
import {CopyOutlined} from "@ant-design/icons";

const MonitorRFC: React.FC = () => {
    const { token: { colorBgContainer },} = theme.useToken();

    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;

    /*
    const { data} = useCommonUseQuery<TB_MONITORING[]>(
        queryKey,
        () =>procAdminService<TB_MONITORING[]>("post", `${serviceCode}ADS24`, null));
    */
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<TB_MONITORING_RFC[]>([]);

    const [dateTime, setDateTime] = useState<string>(getCurrentDateTime);
    const [date, setDate] = useState<string>(dateTime.substring(0, dateTime.indexOf(' ')));
    const [time, setTime] = useState<string>(dateTime.substring(dateTime.indexOf(' ')));

    const [period, setPeriod] = useState<string>('15');
    const [traceId, setTraceId] = useState<string>('');
    const [userId, setUserId] = useState<string>('');
    const [rfcName, setRfcName] = useState<string>('');
    const [isSuccess, setIsSuccess] = useState<string>('');
    const [pagination, setPagination] = useState({
        showSizeChanger: false,
        current:1,
        pageSize: 15,
        total: 0,
    });
    const onSearch = (pageNo:number) => {
        setLoading(true);

        const requestParam = {
            date:dateTime,
            period:period,
            traceId:traceId,
            userId:userId,
            rfcName:rfcName,
            pageNo:pageNo,
            pageSize:pagination.pageSize,
            isSuccess:isSuccess,
        }

        procAdminService<TB_MONITORING_RFC_RETURN>("post", `${serviceCode}ADS25`, requestParam).then(
            (response:TB_MONITORING_RFC_RETURN)=>{
                setData(response.tbMonitoringSaprfcs);
                setPagination({current: pageNo, pageSize: pagination.pageSize, showSizeChanger: pagination.showSizeChanger, total: response.total});
            }
        ).finally(()=>{
            setLoading(false);
        });
    }



    const handleTableChange = (pagination:any) => {
        const { current, pageSize } = pagination;
        onSearch(current);
    };

    const tableStyle:CSSProperties = {
        paddingLeft:'10px'
        , paddingRight:'10px'
        , paddingBottom: '9px'
        , margin:'0'
        , fontSize:'12px'
    }

    const columns: ColumnsType<TB_MONITORING_RFC> = [
        {
            title: 'LoginID',
            dataIndex: 'loginId',
            key: 'loginId',
            width:'130px',
            render: (text: string) =>
                <EllipsisDiv style={tableStyle}>
                    <Tooltip placement="top" arrow={false}title={text}>
                        {text}
                    </Tooltip>
                </EllipsisDiv>
            ,
        },
        {
            title: '추적ID',
            dataIndex: 'traceId',
            key: 'traceId',
            ellipsis:true,
            width:'170px',
            render: (text: string) =>
                <EllipsisDiv style={tableStyle}>
                    <Tooltip placement="top" arrow={false}title={text}>
                        {text}
                    </Tooltip>
                </EllipsisDiv>
            ,
        },
        {
            title: '실행날짜',
            dataIndex: 'firstRegTime',
            key: 'firstRegTime',
            width:'170px',
            render: (text: string) =>
                <div style={{ ...tableStyle, alignItems: 'center', justifyContent: 'center' }}>
                    {formatDate(text)}
                </div>
            ,
        },

        {
            title: 'RFC명',
            key: 'rfcName',
            dataIndex: 'rfcName',
            render: (text:string) =>
                <EllipsisDiv style={tableStyle}>
                    <Tooltip placement="top" arrow={false}title={text}>
                        {text}
                    </Tooltip>
                </EllipsisDiv>
            ,
        },
        {
            title: '수행시간',
            dataIndex: 'runTime',
            key: 'runTime',
            width:'100px',
            render: (text: boolean) =>
                <div style={{ ...tableStyle, alignItems: 'center', justifyContent: 'center', width:80 }}>
                    {text} ms
                </div>
            ,
        },

        {
            title: '성공여부',
            dataIndex: 'success',
            key: 'success',
            width:'80px',
            render: (text: boolean) =>
                <div style={{
                    ...tableStyle,
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 50
                }}>
                    <span style={{
                        display: 'inline-block',
                        height: '15px',
                        width: '15px',
                        backgroundColor: text ? 'green' : 'red',
                        borderRadius: '50%',
                    }}/>
                </div>
            ,
        },
        {
            title: 'Import',
            key: 'inputParam',
            dataIndex: 'inputParam',
            ellipsis:true,
            width:'170px',
            render: (text: string) =>
                text ? (
                    <EllipsisDiv style={tableStyle} >
                        <WizTooltip placement={"topLeft"}  title="복사">
                            <Button type="link" style={{marginLeft:"5px"}} shape="circle" onClick={()=>{handleCopyClick(text).then()}} icon={<CopyOutlined />}/>
                        </WizTooltip>
                        {text}
                    </EllipsisDiv>
                ):(
                    <>
                    </>
                )
            ,
        },
        {
            title: 'EXPORT',
            key: 'exportParam',
            dataIndex: 'exportParam',
            ellipsis:true,
            width:'170px',
            render: (text:string) =>
                text ? (
                    <EllipsisDiv style={tableStyle} >
                        <WizTooltip placement={"topLeft"}  title="복사">
                            <Button type="link" style={{marginLeft:"5px"}} shape="circle" onClick={()=>{handleCopyClick(text).then()}} icon={<CopyOutlined />}/>
                        </WizTooltip>
                        {text}
                    </EllipsisDiv>
                ):(
                    <>
                    </>
                )
            ,
        },
        {
            title: 'Table',
            key: 'tableData',
            dataIndex: 'tableData',
            ellipsis:true,
            width:'170px',
            render: (text: string) =>
                text ? (
                    <EllipsisDiv style={tableStyle} >
                        <WizTooltip placement={"topLeft"}  title="복사">
                            <Button type="link" style={{marginLeft:"5px"}} shape="circle" onClick={()=>{handleCopyClick(text).then()}} icon={<CopyOutlined />}/>
                        </WizTooltip>
                        {text}
                    </EllipsisDiv>
                ):(
                    <>
                    </>
                )
            ,
        },
        {
            title: '에러내용',
            key: 'exceptionTxt',
            dataIndex: 'exceptionTxt',
            ellipsis:true,
            width:'170px',
            render: (text:string) =>
                text ? (
                    <EllipsisDiv style={tableStyle} >
                        <WizTooltip placement={"topLeft"}  title="복사">
                            <Button type="link" style={{marginLeft:"5px"}} shape="circle" onClick={()=>{handleCopyClick(text).then()}} icon={<CopyOutlined />}/>
                        </WizTooltip>
                        {text}
                    </EllipsisDiv>
                ):(
                    <>
                    </>
                )
            ,
        },

    ];


    useEffect(()=>{
        onSearch(1);
    }, []);

    return (
        <>
        <nav style={{
            margin:'0px 0px 14px 0px',
            padding:'9px 8px 9px 0px',
            height: '50px',
            display:'flex',
            justifyContent: "space-between",
            alignItems:'center',
            borderRadius: "8px", // 라운드 처리 추가
            border: '1px solid #dadada',
            background: colorBgContainer,
        }}>
            <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{
                    padding: '9px 5px',
                    display:'flex',
                }}>
                    <ConfigProvider locale={locale}>
                        <DatePicker style={{marginLeft : "5px"}}
                                    value={dayjs(dateTime, 'YYYY-MM-DD HH:mm:ss')}
                                    allowClear={false}
                                    defaultValue={dayjs(dateTime, 'YYYY-MM-DD HH:mm:ss')}
                                    format={'YYYY-MM-DD'}
                                    onChange={(e, dateString:string)=>{
                                        setDate(dateString)
                                        setDateTime(`${dateString} ${time}`);
                                    }}
                        />
                        <TimePicker style={{marginLeft : "10px"}}
                                    allowClear={false}
                                    value={dayjs(time, 'HH:mm:ss')}
                                    defaultValue={dayjs(time, 'HH:mm:ss')}
                                    onChange={(e, timeString:string)=>{
                                        setTime(timeString);
                                        setDateTime(`${date} ${timeString}`);
                                    }}
                        />
                    </ConfigProvider>
                    <Select
                        style={{width:"150px", marginRight:"10px", marginLeft:"10px"}}
                        options={[
                            { value: '5', label: '전후 5분' },
                            { value: '10', label: '전후 10분' },
                            { value: '15', label: '전후 15분' },
                            { value: '20', label: '전후 20분' },
                            { value: '30', label: '전후 30분' },
                            { value: '60', label: '전후 60분' },
                        ]}
                        value={period}
                        onChange={(value, option)=>{setPeriod(value)}}
                        defaultValue={'15'}
                    />
                </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>


                <Input style={{width:"150px", marginRight:"5px", marginLeft:"5px"}}
                        value={traceId}
                        onChange={(e)=>{
                            setTraceId(e.target.value);
                        }}
                        placeholder={"추적ID"}/>
                <Input style={{width:"150px", marginRight:"5px", marginLeft:"5px"}} placeholder={"사용자ID"}
                        value={userId}
                        onChange={(e)=>{
                            setUserId(e.target.value);
                        }}
                />
                <Input style={{width:"150px", marginRight:"5px", marginLeft:"5px"}} placeholder={"RFC명"}
                        value={rfcName}
                        onChange={(e)=>{
                            setRfcName(e.target.value);
                        }}
                />
                <Select
                    style={{width:"150px", marginRight:"10px", marginLeft:"10px"}}
                    options={[
                        { value: '', label: '전체' },
                        { value: '1', label: '성공' },
                        { value: '0', label: '실패' },
                    ]}
                    onChange={(value, option)=>{
                        setIsSuccess(value);
                    }}
                    value={isSuccess}
                    defaultValue={''}
                />
                <Button style={{marginRight:"5px", marginLeft:"5px"}}type="primary" size="small" onClick={()=>{onSearch(1)}}>조회</Button>
            </div>
        </nav>
        <Table columns={columns}
                loading={loading}
                dataSource={data}
                pagination={pagination}
                rowKey="traceId"
                onChange={handleTableChange}
        />
        </>
    );
};

export default MonitorRFC;
